module.exports = __webpack_public_path__ + "img/american.b6f210e6.png";